import { Box, Container } from "@material-ui/core";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { useStyles } from "../quoteDetail.styles";
import { EQuoteType } from "../../../api/Types";

export const Title = ({ name, quoteType }: { name: string; quoteType: EQuoteType }) => {
  const classes = useStyles();
  const { isMoreThanSm } = useBreakpoint();

  return (
    <Container maxWidth={"lg"}>
      <Box
        fontSize={isMoreThanSm ? "28px" : "20px"}
        fontWeight={500}
        color="#1e073f"
        textAlign={"center"}
        mt={isMoreThanSm ? 6 : 4}
      >
        Hi {name},<br />
        Did you know <span className={classes.colorOrange}>Swyft Energy</span> is owned by{" "}
        <span className={classes.colorOrange}>BORD GÁIS ENERGY!</span>
        <br />
        Here is your quote:
      </Box>
    </Container>
  );
};
